export enum ERealtimePresenceAction {
  Join = "join",
  Leave = "leave",
}
